import Vue from "vue";
import Router from "vue-router";
import store from "../store/state";
Vue.use(Router);
// 此处定义外链path路径
const path = "/index.html";
const pathCdn = "/xdxh/index.html";
// const path = '/';

console.log("router process.env", process.env, process.env.ROUTER_BASE);

/**
 *  路由懒加载处理，随着组件越来越多，优化首屏加载速度慢问题
 */
let router = new Router({
  mode: "history",
  base: process.env.ROUTER_BASE,
  routes: [
    {
      path: "/activity",
      name: "Activity",
      component: resolve => require(["@/components/activity"], resolve)
    },
    {
      path: "/exam",
      name: "Exam",
      component: resolve => require(["@/components/exam"], resolve)
    },
    {
      path: "/hitEgg",
      name: "hitEgg",
      component: resolve => require(["@/components/goldenEgg"], resolve)
    },
    {
      path: "/matchmakerRecruit",
      name: "matchmakerRecruit",
      component: resolve => require(["@/components/matchmakerRecruit"], resolve)
    },
    {
      path: "/certification",
      name: "certification",
      component: resolve => require(["@/components/certification"], resolve)
    },
    {
      path: "/maintainRight",
      name: "maintainRight",
      component: resolve => require(["@/components/maintainRight"], resolve)
    },
    {
      path: "/matchmakerCollege",
      name: "matchmakerCollege",
      component: resolve => require(["@/components/matchmakerCollege"], resolve)
    },
    {
      path: "/collegeItem",
      name: "collegeItem",
      component: resolve => require(["@/components/collegeItem"], resolve)
    },
    {
      path: "/matchmakerRule",
      name: "matchmakerRule",
      component: resolve => require(["@/components/matchmakerRule"], resolve)
    },
    {
      path: "/examList",
      name: "examlist",
      component: resolve => require(["@/components/examList"], resolve)
    },
    {
      path: "/hpAtionEp",
      name: "hpAtionEp",
      component: resolve => require(["@/components/hpAtionEp"], resolve)
    },
    ,
    {
      path: "/regulation",
      name: "regulation",
      component: resolve => require(["@/components/regulation"], resolve)
    },
    {
      path: "/personRecord",
      name: "personRecord",
      component: resolve => require(["@/components/personRecord"], resolve)
    },
    {
      path: "/address",
      name: "address",
      component: resolve => require(["@/components/address"], resolve)
    },
    {
      path: "/eggSendReward",
      name: "eggSendReward",
      component: resolve => require(["@/components/eggSendReward"], resolve)
    },
    {
      path: "/vipActivity",
      name: "vipActivity",
      component: resolve => require(["@/components/vipActivity"], resolve)
    },
    {
      path: "/levelExplain",
      name: "levelExplain",
      component: resolve => require(["@/components/levelExplain"], resolve)
    },
    {
      path: "/inviteAgent",
      name: "inviteAgent",
      component: resolve => require(["@/components/inviteAgent"], resolve)
    },
    {
      path: "/userPlay",
      name: "userPlay",
      component: resolve => require(["@/components/userPlay"], resolve)
    },
    {
      path: "/bindDownload",
      name: "bindDownload",
      component: resolve => require(["@/components/bindDownload"], resolve)
    },
    {
      path: "/activitySignInUser",
      name: "activitySignInUser",
      component: resolve => require(["@/components/activitySignInUser"], resolve) //新用户注册页面
    },
    {
      path: "/cloth",
      name: "cloth",
      component: resolve => require(["@/components/cloth"], resolve)
    },
    {
      path: "/sdkProduce",
      name: "sdkProduce",
      component: resolve => require(["@/components/sdkProduce"], resolve)
    },
    {
      path: "/sdkIframe",
      name: "sdkIframe",
      component: resolve => require(["@/components/sdkIframe"], resolve)
    },
    {
      path: "/miaiContract",
      name: "miaiContract",
      component: resolve => require(["@/components/miaiContract"], resolve)
    },
    {
      path: "/miaiContractTest",
      name: "miaiContractTest",
      component: resolve => require(["@/components/miaiContractTest"], resolve)
    },
    {
      path: "/chargeAgreement",
      name: "chargeAgreement",
      component: resolve => require(["@/components/chargeAgreement"], resolve)
    },
    {
      path: "/inviteActivityRule",
      name: "inviteActivityRule",
      component: resolve =>
        require(["@/components/inviteActivityRule"], resolve)
    },
    {
      path: "/inviteActivityTodo",
      name: "inviteActivityTodo",
      component: resolve =>
        require(["@/components/inviteActivityTodo"], resolve)
    },
    {
      path: "/settingAdmin",
      name: "settingAdmin",
      component: resolve => require(["@/components/settingAdmin"], resolve)
    },
    {
      path: "/qqsAdminCharge",
      name: "qqsAdminCharge",
      component: resolve => require(["@/components/qqsAdminCharge"], resolve)
    },
    {
      path: "/inviteList",
      name: "inviteList",
      component: resolve => require(["@/components/inviteList"], resolve)
    },
    {
      path: "/auctionIntroduce",
      name: "auctionIntroduce",
      component: resolve => require(["@/components/auctionIntroduce"], resolve)
    },
    {
      path: "/invitePublic",
      name: "invitePublic",
      component: resolve => require(["@/components/invitePublic"], resolve)
    },
    {
      path: "/officeCode",
      name: "officeCode",
      component: resolve => require(["@/components/officeCode"], resolve)
    },
    {
      path: "/withdrawAgree",
      name: "withdrawAgree",
      component: resolve => require(["@/components/withdrawAgree"], resolve)
    },
    {
      path: "/bindBank",
      name: "bindBank",
      component: resolve => require(["@/components/bindBank"], resolve)
    },
    {
      path: "/bankProblem",
      name: "bankProblem",
      component: resolve => require(["@/components/bankProblem"], resolve)
    },
    {
      path: "/invoiceTable",
      name: "invoiceTable",
      component: resolve => require(["@/components/invoiceTable"], resolve)
    },
    {
      path: "/invoiceIndex",
      name: "invoiceIndex",
      component: resolve => require(["@/components/invoiceIndex"], resolve)
    },
    {
      path: "/invoiceHistory",
      name: "invoiceHistory",
      component: resolve => require(["@/components/invoiceHistory"], resolve)
    },
    {
      path: "/invoiceDetail",
      name: "invoiceDetail",
      component: resolve => require(["@/components/invoiceDetail"], resolve)
    },
    {
      path: "/invoiceOrderDetail",
      name: "invoiceOrderDetail",
      component: resolve =>
        require(["@/components/invoiceOrderDetail"], resolve)
    },
    {
      path: "/invoiceUserMsg",
      name: "invoiceUserMsg",
      component: resolve => require(["@/components/invoiceUserMsg"], resolve)
    },
    {
      path: "/invoiceSuccess",
      name: "invoiceSuccess",
      component: resolve => require(["@/components/invoiceSuccess"], resolve)
    },
    {
      path: "/invoiceBook",
      name: "invoiceBook",
      component: resolve => require(["@/components/invoiceBook"], resolve)
    },
    {
      path: "/chargeTest",
      name: "chargeTest",
      component: resolve => require(["@/components/chargeTest"], resolve)
    },
    {
      path: "/couponRule",
      name: "couponRule",
      component: resolve => require(["@/components/couponRule"], resolve)
    },
    {
      path: "/withdrawRecord",
      name: "withdrawRecord",
      component: resolve => require(["@/components/withdrawRecord"], resolve)
    },
    {
      path: "/taxdetail",
      name: "taxdetail",
      component: resolve => require(["@/components/taxdetail"], resolve)
    },
    {
      path: "/angelRule",
      name: "angelRule",
      component: resolve => require(["@/components/angelRule"], resolve)
    },
    {
      path: "/activityDuanWu2022",
      name: "activityDuanWu2022",
      component: resolve =>
        require(["@/components/activityDuanWu2022"], resolve)
    },
    {
      path: "/activityRunningLove2022",
      name: "activityRunningLove2022",
      component: resolve =>
        require(["@/components/activityRunningLove2022"], resolve)
    },
    {
      path: "/activityQixi2022",
      name: "activityQixi2022",
      component: resolve => require(["@/components/activityQixi2022"], resolve)
    },
    {
      path: "/loginProblem",
      name: "loginProblem",
      component: resolve => require(["@/components/loginProblem"], resolve)
    },
    {
      path: "/customer/customerMsg",
      name: "customerMsg",
      component: resolve =>
        require(["@/components/customer/customerMsg"], resolve)
    },
    {
      path: "/loginToConsult",
      name: "loginToConsult",
      component: resolve => require(["@/components/loginToConsult"], resolve)
    },
    {
      path: "/customer/customerChat",
      name: "customerChat",
      component: resolve =>
        require(["@/components/customer/customerChat"], resolve)
    },
    {
      path: "/customer/customerAutoApply",
      name: "customerAutoApply",
      component: resolve =>
        require(["@/components/customer/customerAutoApply"], resolve)
    },
    {
      path: "/customer/customerUserInfo",
      name: "customerUserInfo",
      component: resolve =>
        require(["@/components/customer/customerUserInfo"], resolve)
    },
    {
      path: "/customer/customerEditApply",
      name: "customerEditApply",
      component: resolve =>
        require(["@/components/customer/customerEditApply"], resolve)
    },
    {
      path: "/customer/middleLoading",
      name: "middleLoading",
      component: resolve =>
        require(["@/components/customer/middleLoading"], resolve)
    },
    {
      path: "/customer/customerSearch",
      name: "customerSearch",
      component: resolve =>
        require(["@/components/customer/customerSearch"], resolve)
    },
    {
      path: "/customer/customerSearchRes",
      name: "customerSearchRes",
      component: resolve =>
        require(["@/components/customer/customerSearchRes"], resolve)
    },
    {
      path: "/activityMoon2022",
      name: "activityMoon2022",
      component: resolve => require(["@/components/activityMoon2022"], resolve)
    },
    {
      path: "/activityNation2022",
      name: "activityNation2022",
      component: resolve =>
        require(["@/components/activityNation2022"], resolve)
    },
    {
      path: "/xqDownload",
      name: "xqDownload",
      component: resolve => require(["@/components/xqDownload"], resolve)
    },
    {
      path: "/activityHalloween2022",
      name: "activityHalloween2022",
      component: resolve =>
        require(["@/components/activityHalloween2022"], resolve)
    },
    {
      path: "/checkUpdate",
      name: "checkUpdate",
      component: resolve => require(["@/components/checkUpdate"], resolve)
    },
    {
      path: "/activityDouble112022",
      name: "activityDouble112022",
      component: resolve =>
        require(["@/components/activityDouble112022"], resolve)
    },
    {
      path: "/activityTurkeyDay2022",
      name: "activityTurkeyDay2022",
      component: resolve =>
        require(["@/components/activityTurkeyDay2022"], resolve)
    },
    {
      path: "/activitySnow2022",
      name: "activitySnow2022",
      component: resolve => require(["@/components/activitySnow2022"], resolve)
    },
    {
      path: "/roomGame",
      name: "roomGame",
      component: resolve => require(["@/components/roomGame"], resolve)
    },
    {
      path: "/activityChristmas2022",
      name: "activityChristmas2022",
      component: resolve =>
        require(["@/components/activityChristmas2022"], resolve)
    },
    {
      path: "/activityNewYear2023",
      name: "activityNewYear2023",
      component: resolve =>
        require(["@/components/activityNewYear2023"], resolve)
    },
    {
      path: "/inviteActivity2023",
      name: "inviteActivity2023",
      component: resolve =>
        require(["@/components/inviteActivity2023"], resolve)
    },
    {
      path: "/activitySpringDay2023",
      name: "activitySpringDay2023",
      component: resolve =>
        require(["@/components/activitySpringDay2023"], resolve)
    },
    {
      path: "/activityNewYearEve2023",
      name: "activityNewYearEve2023",
      component: resolve =>
        require(["@/components/activityNewYearEve2023"], resolve)
    },
    {
      path: "/activityNewYearEve2024",
      name: "activityNewYearEve2024",
      component: resolve =>
        require(["@/components/activityNewYearEve2024"], resolve)
    },
    {
      path: "/activityNewYearSpring2024",
      name: "activityNewYearSpring2024",
      component: resolve =>
        require(["@/components/activityNewYearSpring2024"], resolve)
    },
    {
      path: "/activityNewYearSweet2024",
      name: "activityNewYearSweet2024",
      component: resolve =>
        require(["@/components/activityNewYearSweet2024"], resolve)
    },
    {
      path: "/activityWomenDay2024",
      name: "activityWomenDay2024",
      component: resolve =>
        require(["@/components/activityWomenDay2024"], resolve)
    },
    {
      path: "/servicePage",
      name: "servicePage",
      component: resolve =>
        require(["@/components/servicePage"], resolve)
    },
    {
      path: "/roomTreasure",
      name: "roomTreasure",
      component: resolve =>
        require(["@/components/roomTreasure"], resolve)
    },
    {
      path: "/activityLantern2023",
      name: "activityLantern2023",
      component: resolve =>
        require(["@/components/activityLantern2023"], resolve)
    },
    {
      path: "/activity02142023",
      name: "activity02142023",
      component: resolve => require(["@/components/activity02142023"], resolve)
    },
    {
      path: "/activityGoddess2023",
      name: "activityGoddess2023",
      component: resolve =>
        require(["@/components/activityGoddess2023"], resolve)
    },
    {
      path: "/activityAngel2023",
      name: "activityAngel2023",
      component: resolve => require(["@/components/activityAngel2023"], resolve)
    },
    {
      path: "/activitySakura2023",
      name: "activitySakura2023",
      component: resolve =>
        require(["@/components/activitySakura2023"], resolve)
    },
    {
      path: "/activitySpringOut2023",
      name: "activitySpringOut2023",
      component: resolve =>
        require(["@/components/activitySpringOut2023"], resolve)
    },
    {
      path: "/activityTax",
      name: "activityTax",
      component: resolve =>
        require(["@/components/activityTax"], resolve)
    },
    {
      path: "/ktvList",
      name: "ktvList",
      component: resolve => require(["@/components/ktvList"], resolve)
    },
    {
      path: "/ktvListRule",
      name: "ktvListRule",
      component: resolve => require(["@/components/ktvListRule"], resolve)
    },
    {
      path: "/activityHappyLabour2023",
      name: "activityHappyLabour2023",
      component: resolve =>
        require(["@/components/activityHappyLabour2023"], resolve)
    },
    {
      path: "/activity5202023",
      name: "activity5202023",
      component: resolve => require(["@/components/activity5202023"], resolve)
    },
    {
      path: "/levelSystem",
      name: "levelSystem",
      component: resolve => require(["@/components/levelSystem"], resolve)
    },
    {
      path: "/activity612023",
      name: "activity612023",
      component: resolve => require(["@/components/activity612023"], resolve)
    },
    {
      path: "/illegalTrading",
      name: "illegalTrading",
      component: resolve => require(["@/components/illegalTrading"], resolve)
    },
    {
      path: "/activityDuanWu2023",
      name: "activityDuanWu2023",
      component: resolve =>
        require(["@/components/activityDuanWu2023"], resolve)
    },
    {
      path: "/auctionList",
      name: "auctionList",
      component: resolve => require(["@/components/auctionList"], resolve)
    },
    // {
    //   path: "/auctionListRule",
    //   name: "auctionListRule",
    //   component: resolve => require(["@/components/auctionListRule"], resolve)
    // }
    {
      path: "/activityThreeYear2023",
      name: "activityThreeYear2023",
      component: resolve =>
        require(["@/components/activityThreeYear2023"], resolve)
    },
    {
      path: "/activityWatermelon2023",
      name: "activityWatermelon2023",
      component: resolve =>
        require(["@/components/activityWatermelon2023"], resolve)
    },
    {
      path: "/activityWatermelon2022",
      name: "activityWatermelon2022",
      component: resolve =>
        require(["@/components/activityWatermelon2022"], resolve)
    },
    {
      path: "/activityLovers2023",
      name: "activityLovers2023",
      component: resolve =>
        require(["@/components/activityLovers2023"], resolve)
    },
    {
      path: "/activityRule",
      name: "activityRule",
      component: resolve =>
        require(["@/components/activityRule"], resolve)
    },
    {
      path: "/oldRecall",
      name: "oldRecall",
      component: resolve =>
        require(["@/components/oldRecall"], resolve)
    },
    {
      path: "/pkList",
      name: "pkList",
      component: resolve => require(["@/components/pkList"], resolve)
    },
    {
      path: "/vipPrivilege",
      name: "vipPrivilege",
      component: resolve =>
        require(["@/components/vipPrivilege"], resolve)
    },
    {
      path: "/vipMyPrivilege",
      name: "vipMyPrivilege",
      component: resolve =>
        require(["@/components/vipMyPrivilege"], resolve)
    },
    {
      path: "/vipMyPrivilegeRule",
      name: "vipMyPrivilegeRule",
      component: resolve =>
        require(["@/components/vipMyPrivilegeRule"], resolve)
    },
    {
      path: "/vipRankHide",
      name: "vipRankHide",
      component: resolve =>
        require(["@/components/vipRankHide"], resolve)
    },
    {
      path: "/vipSpeakerCard",
      name: "vipSpeakerCard",
      component: resolve =>
        require(["@/components/vipSpeakerCard"], resolve)
    },
    {
      path: "/vipKnight",
      name: "vipKnight",
      component: resolve =>
        require(["@/components/vipKnight"], resolve)
    },
    {
      path: "/vipKnightEdit",
      name: "vipKnightEdit",
      component: resolve =>
        require(["@/components/vipKnightEdit"], resolve)
    },
    {
      path: "/vipKnightEditDetail",
      name: "vipKnightEditDetail",
      component: resolve =>
        require(["@/components/vipKnightEditDetail"], resolve)
    },
    {
      path: "/vipIntroduce",
      name: "vipIntroduce",
      component: resolve =>
        require(["@/components/vipIntroduce"], resolve)
    },
    {
      path: "/activityTeacher2023",
      name: "activityTeacher2023",
      component: resolve =>
        require(["@/components/activityTeacher2023"], resolve)
    },
    {
      path: "/activityMoon2023",
      name: "activityMoon2023",
      component: resolve =>
        require(["@/components/activityMoon2023"], resolve)
    },
    {
      path: "/activityNation2023",
      name: "activityNation2023",
      component: resolve =>
        require(["@/components/activityNation2023"], resolve)
    },
    {
      path: "/activityHalloween2023",
      name: "activityHalloween2023",
      component: resolve =>
        require(["@/components/activityHalloween2023"], resolve)
    },
    {
      path: "/activityChristmas2023",
      name: "activityChristmas2023",
      component: resolve =>
        require(["@/components/activityChristmas2023"], resolve)
    },
    {
      path: "/activityNewYear2024",
      name: "activityNewYear2024",
      component: resolve =>
        require(["@/components/activityNewYear2024"], resolve)
    },
    {
      path: "/logout",
      name: "logout",
      component: resolve =>
        require(["@/components/logout"], resolve)
    },
    {
      path: "/logoutG",
      name: "logoutG",
      component: resolve =>
        require(["@/components/logoutG"], resolve)
    },
    {
      path: "/fishing",
      name: "fishing",
      component: resolve => require(["@/components/fishing"], resolve)
    },
    {
      path: "/agentDiamond",
      name: "agentDiamond",
      component: resolve => require(["@/components/agentDiamond"], resolve)
    },
    {
      path: "/activityRecruit",
      name: "activityRecruit",
      component: resolve => require(["@/components/activityRecruit"], resolve)
    },
    {
      path: "/activityAnniversary",
      name: "activityAnniversary",
      component: resolve => require(["@/components/activityAnniversary"], resolve)
    },
    {
      path: "/activityReturnUser",
      name: "activityReturnUser",
      component: resolve => require(["@/components/activityReturnUser"], resolve) //用户回归页面
    },
    {
      path: "/activityExcessivePage",
      name: "activityExcessivePage",
      component: resolve => require(["@/components/activityExcessivePage"], resolve) //用户回归过度页面
    },
    {
      path: "/activityConversion",
      name: "activityConversion",
      component: resolve => require(["@/components/activityConversion"], resolve)
    },
    
  ]
});

//Router全局前置守卫
router.beforeEach((to, from, next) => {
  console.log("to", to);
  console.log("path", path);
  console.log("我是心动pathCdn", pathCdn);
  // 判断路由path，首次进入为`/`，query中的page为跳转的路由及组件,page值要与routes中的path一致
  if ((to.path === path || to.path === pathCdn) && to.query.page) {
    console.log("query中的page为跳转的路由及组件,page值要与routes中的path一致");
    router.replace({
      path: to.query.page,
      query: to.query,
      params: to.params
    });
  } else if (to.path === path && !to.query.page && to.query.type) {
    // 原有系统里的参数配置，保留跳转path
    console.log("原有系统里的参数配置，保留跳转path");
    router.replace({
      path: "/activity",
      query: to.query,
      params: to.params
    });
  } else if (to.path === pathCdn && !to.query.page && to.query.type) {
    // 原有系统里的参数配置，保留跳转path
    console.log("原有系统里的参数配置，保留跳转pathCdn");
    router.replace({
      path: "/activity",
      query: to.query,
      params: to.params
    });
  } else if (to.path === "/chargeAgreement") {
    router.afterEach((to, from, next) => {
      document.querySelector("body").setAttribute("style", "overflow: auto !important;")
    });
  } else {
    // 非`/`path，保留跳转
    console.log("保留跳转");

  }
  console.log('跳转路由');
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js